<template>
  <div class="header">
    <div class="left">
      <h1 class="subtitle">Feltragem | Needle Felting</h1>
      <h1 class="title">Fazendo arte com muito dengo e todo amor do mundo!</h1>
      <button class="more" @click="goToView">Saiba Mais +</button>
    </div>
    <div class="right">
      <img src="@/assets/header-img.svg" alt="Dengo e Arte Pet" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToView() {
      const el = document.getElementById('products');
      el.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #5ec6ee;
  height: 55vh;
  clip-path: polygon(100% 0%, 0% 0%, 0% 92%, 50% 100%, 100% 92%);
  display: flex;
  text-align: left;
  align-items: center;
  padding: 0 80px;
  justify-content: space-evenly;
  margin-top: -20px;
}

.left {
  width: 320px;
}

.title,
.subtitle,
.more {
  color: white;
  font-family: 'Poppins', sans-serif;
}

.title {
  margin: 5px 0 10px;
}

.subtitle {
  text-transform: uppercase;
  font-size: 16px;
}

.more {
  background-color: #b62968;
  border: none;
  text-transform: uppercase;
  border-radius: 25px;
  padding: 6px 25px;
}

@media screen and (max-width: 560px) {
  .header {
    height: 35vh;
    padding: 0 30px;
  }

  .left {
    width: 100%;
    padding-bottom: 20px;
  }

  .title {
    font-size: 26px;
  }

  .subtitle {
    font-size: 14px;
  }

  .right {
    display: none;
  }
}

@media screen and (min-width: 560px) {
  .title {
    font-size: 24px;
  }

  .right {
    width: 240px;
  }
}

@media screen and (min-width: 768px) {
  .title {
    font-size: 32px;
  }

  .left {
    width: 520px;
  }

  .right {
    width: 350px;
  }
}
</style>
